import { Component, OnInit } from '@angular/core';
import {MatBottomSheet} from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-android-pwa-intro',
  templateUrl: './android-pwa-intro.component.html',
  styleUrls: ['./android-pwa-intro.component.css']
})
export class AndroidPwaIntroComponent implements OnInit {

  constructor(private bottomSheet: MatBottomSheet) { }

  ngOnInit(): void {
  }
  dismiss(): void{
    this.bottomSheet.dismiss();
  }
  remindMeLater(): any{
    localStorage.setItem('androidIntro', 'no');
    this.bottomSheet.dismiss();
  }
  understand(): any{
    localStorage.setItem('androidIntro', 'yes');
    this.bottomSheet.dismiss();
  }

}
